import { isBrowser } from './dom.js';

/**
 * Simplely return current page location href.
 * @returns
 */
export const getFullUrlHref = () => {
  return isBrowser ? window.location.href : '';
};
